import { handleIdentityPropsChangeProps } from '../_props'
import { PatientIdentityStatusEnum } from '../../_props'
import { patientIdentityStatusCodesMap } from './_utils'
import useAutomaticIdentityValidation from '../../../../../hooks/useAutomaticIdentityValidation'
import { useRegradeIdentity } from '../../services/usePatientUtils'

const useHandleIdentityPropsChange = () => {
    const { isAutomaticIdentityValidationDisabled } = useAutomaticIdentityValidation()
    const { regradeIdentity } = useRegradeIdentity()

    const handleIdentityPropsChange = ({
        identityProofCode,
        identityAttributesCodes,
        originalIdentityCode,
        insOid,
    }: handleIdentityPropsChangeProps): Promise<PatientIdentityStatusEnum> =>
        new Promise((resolve) => {
            let result: PatientIdentityStatusEnum = patientIdentityStatusCodesMap[originalIdentityCode ?? 1]

            if (!insOid) {
                result = regradeIdentity('set', undefined, 'PROVISIONAL')
            }

            result = regradeIdentity('reprocess', identityProofCode)

            if (identityAttributesCodes?.includes(3) || identityAttributesCodes?.includes(2)) {
                result = regradeIdentity('set', undefined, 'PROVISIONAL')
            } else if (!isAutomaticIdentityValidationDisabled) {
                result = regradeIdentity('reprocess', identityProofCode)
            }

            resolve(result)
        })

    return {
        handleIdentityPropsChange,
    }
}

export default useHandleIdentityPropsChange
